import { SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import clsx from 'clsx'
import { ExtendedSvgIcon } from 'components/ActionBar'
import React from 'react'

const InsertSpecifierNoteIcon: OverridableComponent<SvgIconTypeMap<
    {},
    'svg'
>> = (props: any) => (
    <ExtendedSvgIcon
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={clsx('InsertSpecifierNoteIcon', props.className)}
    >
        <path
            d="M4.73744 4.55556H13.6263M4.73744 7.22222H13.6263M4.73744 9.88889H8.293M1.18188 13.4444V2.77778C1.18188 2.30628 1.36919 1.8541 1.70258 1.5207C2.03598 1.1873 2.48817 1 2.95966 1H15.4041C15.8756 1 16.3278 1.1873 16.6612 1.5207C16.9946 1.8541 17.1819 2.30628 17.1819 2.77778V11.6667C17.1819 12.1382 16.9946 12.5903 16.6612 12.9237C16.3278 13.2571 15.8756 13.4444 15.4041 13.4444H5.33033C4.94567 13.4444 4.57139 13.5692 4.26366 13.8L1.18188 16.1111V13.4444Z"
            stroke="#314959"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </ExtendedSvgIcon>
)

export default InsertSpecifierNoteIcon
